import { t } from '../../i18n'
import { ServiceSessionType, SessionPayload } from './types'

const scope = 'controls'

export const SESSION_START_COMMAND = 'start_service_session'
export const SESSION_FINISH_COMMAND = 'finish_service_session'

// The Control page starts and ends `operator` sessions and nothing else. Any other type
// belongs to the mobile Service app and locks this page until it is ended there.
export const isOperatorSession = (session: SessionPayload) => session.service_type === 'operator'

const SESSION_TYPE_LABEL_KEYS: Record<ServiceSessionType, string> = {
  operator: 'service_session_types.operator',
  maintenance: 'service_session_types.maintenance',
  cleaning: 'service_session_types.cleaning',
  replenishment: 'service_session_types.replenishment',
  forced_replenishment: 'service_session_types.forced_replenishment',
  move_mode_testing: 'service_session_types.move_mode_testing',
}

export const sessionTypeName = (serviceType?: ServiceSessionType | null) =>
  t(
    (serviceType && SESSION_TYPE_LABEL_KEYS[serviceType]) ?? 'service_session_types.unknown',
    { scope },
  )

export const sessionBlockedText = (serviceType?: ServiceSessionType | null) =>
  t('session_blocked_tooltip', { scope, session_type: sessionTypeName(serviceType) })
